import { render, staticRenderFns } from "./dataBoard.vue?vue&type=template&id=4d895ddd&scoped=true"
import script from "./dataBoard.vue?vue&type=script&lang=js"
export * from "./dataBoard.vue?vue&type=script&lang=js"
import style0 from "./dataBoard.vue?vue&type=style&index=0&id=4d895ddd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d895ddd",
  null
  
)

export default component.exports